import type { SdkWidgetSettings } from '../types';
import { el } from './dom-utils';
// @ts-expect-error Vite ?raw import
import poweredBySvg from '../assets/veridion-poweredby.svg?raw';
// @ts-expect-error Vite ?raw import
import poweredByDarkSvg from '../assets/veridion-poweredby-darkmode.svg?raw';

const POWERED_BY_DATA_URL =
  'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(poweredBySvg as string);
const POWERED_BY_DARK_DATA_URL =
  'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(poweredByDarkSvg as string);

/** Veridion "Powered by" image — append to banner, modal, or consent panel. Uses dark-mode SVG when theme is dark or auto (system dark). */
export function createVeridionBranding(theme?: SdkWidgetSettings['theme']): HTMLElement {
  const wrap = el('div', { className: 'vrd-branding' });
  const effectiveTheme = (theme || 'light').toLowerCase();
  const useDark =
    effectiveTheme === 'dark' ||
    (effectiveTheme === 'auto' && typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches);

  if (effectiveTheme === 'auto') {
    wrap.classList.add('vrd-branding--auto');
    const imgLight = el('img', {
      src: POWERED_BY_DATA_URL,
      alt: 'Veridion powered by Oziriz31',
      className: 'vrd-branding__img vrd-branding__img--light',
    }) as HTMLImageElement;
    const imgDark = el('img', {
      src: POWERED_BY_DARK_DATA_URL,
      alt: 'Veridion powered by Oziriz31',
      className: 'vrd-branding__img vrd-branding__img--dark',
    }) as HTMLImageElement;
    wrap.appendChild(imgLight);
    wrap.appendChild(imgDark);
  } else {
    const img = el('img', {
      src: useDark ? POWERED_BY_DARK_DATA_URL : POWERED_BY_DATA_URL,
      alt: 'Veridion powered by Oziriz31',
      className: 'vrd-branding__img',
    }) as HTMLImageElement;
    wrap.appendChild(img);
  }
  return wrap;
}
